import { ColorsStyles as Colors } from "../Settings/Components/ColorsStyles";

export const ColorsStyles = {
    colorButton: Colors.colorButton,
    colorTextError: Colors.colorTextError,
    backgroundFooter: Colors.backgroundFooter,
    colorHr: Colors.backgroundFooter,
    colorInput: Colors.colorInput,
    background: Colors.background,
    backgroundTwo: Colors.backgroundTwo,
    backgroundTwoHover: Colors.backgroundTwoHover,
    backgroundInput: Colors.backgroundInput,
    borderInput: Colors.borderInput,
    colorTextInput: Colors.colorTextInput,
};
